import React from 'react';
import { useLearn } from '../../contexts/LearnContext';
import { HelpCircle } from 'lucide-react';

interface MethodologyTooltipProps {
    lessonId: string;
    text?: string;
    className?: string;
}

/**
 * A contextual tooltip that links directly to a Magnus Academy lesson.
 * Used for "Just-in-Time" learning within Wizards and Editors.
 */
export const MethodologyTooltip: React.FC<MethodologyTooltipProps> = ({ lessonId, text, className }) => {
    const { openLesson } = useLearn();

    return (
        <div className={`group relative inline-flex items-center gap-1 cursor-help ${className}`}>
            {text && <span className="border-b border-dotted border-blue-400/50 hover:text-blue-500 transition-colors">{text}</span>}
            <HelpCircle size={16} className="text-blue-500 opacity-70 group-hover:opacity-100 transition-opacity" />

            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-4 rounded-xl bg-slate-900 border border-slate-700 text-white text-xs shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-[100] scale-95 group-hover:scale-100">
                <p className="mb-3 text-slate-300 leading-relaxed text-left">
                    This field is a critical requirement of the <span className="text-blue-400 font-bold italic">Living Reliability</span> methodology.
                </p>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        openLesson(lessonId);
                    }}
                    className="w-full py-2 bg-blue-600/20 border border-blue-500/50 rounded-lg text-blue-400 hover:bg-blue-600 hover:text-white font-bold transition-all text-center"
                >
                    Learn Methodology →
                </button>
                <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-slate-900" />
            </div>
        </div>
    );
};

export default MethodologyTooltip;
